import { VideoPlayer } from './video';
import { Tabs } from './tabs';
import { Menu } from './menu';
import Glide, {
  Controls,
  Breakpoints
} from '@glidejs/glide/dist/glide.modular.esm';

document.addEventListener('DOMContentLoaded', () => {
  new Menu(document.querySelector('.site-nav'));

  if (document.getElementById('video-player')) {
    new VideoPlayer({
      el: document.getElementById('video-player'),
      playButton: document.getElementById('video-play')
    });
  }

  const tabEls = [...document.querySelectorAll('.tabs')];
  tabEls.forEach(tabEl => new Tabs(tabEl));

  const glides = [...document.querySelectorAll('.glide')];

  glides.forEach(glide =>
    new Glide(glide, {
      type: 'slider',
      startAt: 0,
      perView: 3,
      focusAt: 0,
      gap: 48,
      animationDuration: 800,
      breakpoints: {
        768: {
          perView: 1
        }
      }
    }).mount({ Controls, Breakpoints })
  );
});
